import axios from "axios";
import { useEffect, useState } from "react";
import { pageArray } from "../components/pagination/helpers";

const useAxios = (endPoint) => {
	let baseUrl = window.origin;
	let reqUrl = `${baseUrl}/wp-json/americanrivers/v1/${endPoint}`;
	const [response, setResponse] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [totalPages, setTotalPages] = useState([]);

	useEffect(() => {
		const getResponse = async () => {
			setIsLoading(true);
			try {
				const response = await axios.get(reqUrl);
				let dataArray = response.data.data;

				setIsLoading(false);
				if (dataArray.length) {
					setResponse([...dataArray]);
					// not all responses will have postCount so we check for it here
					if (response.data.postCount) {
						setTotalPages(pageArray(Math.ceil(response.data.postCount / 12)));
					}
				} else {
					setResponse([]);
				}
			} catch (error) {
				setIsLoading(false);
				throw new Error("Api request failed", { cause: error });
			}
		};
		getResponse();
	}, [endPoint]);

	return { response, isLoading, totalPages };
};

export default useAxios;
